import React, { Component } from 'react';

import { MediaInstagram, MediaFacebook } from '../../components/share';

class MediaComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 'instagram'
    };
  }

  onChangeType = (type) => {
    this.setState({ type });
  };

  renderMedia = () => {
    const { item } = this.props;
    if (this.state.type === 'instagram') {
      return (
        <MediaInstagram
          item={item}
          type={this.state.type}
          onChangeType={this.onChangeType}
        />
      );
    }

    return (
      <MediaFacebook
        item={item}
        type={this.state.type}
        onChangeType={this.onChangeType}
      />
    );
  };

  render() {
    return this.renderMedia();
  }
}

export default MediaComponent;



// WEBPACK FOOTER //
// ./src/components/share/Media.js